import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { TCustomField } from 'src/app/project/modules/custom-fields/custom-fields.model';
import { GET_CUSTOM_FIELDS } from 'src/app/project/modules/custom-fields/custom-fields.store';
import { EAdvancedFilterOptions } from '../../../../models/advanced-filter-options.enum';
import {
  TAdvancedFilterList,
  TAdvancedFilterListValue,
  TAdvancedFilterSingle,
  TFilterListOptions,
} from '../../../../models/advanced-filter.model';

import { listOperatorOptions } from '../../../../utils/advanced-filter-operator.utils';

@Component({
  selector: 'pp-advanced-filter-list',
  templateUrl: './advanced-filter-list.component.html',
  styleUrls: ['./advanced-filter-list.component.scss'],
  standalone: false,
})
export class AdvancedFilterListComponent {
  @Input() ppFilter: TAdvancedFilterSingle;
  @Output() ppFilterChange = new EventEmitter<TAdvancedFilterSingle>();

  value: TAdvancedFilterListValue;
  option: TFilterListOptions;
  filter: TAdvancedFilterList;
  unit: string;
  field: TCustomField;

  advancedFilterListOptions = listOperatorOptions;
  EAdvancedFilterOptions = EAdvancedFilterOptions;

  private lastEmittedSnapshot = '';

  ngOnChanges(): void {
    const snapshot: string = JSON.stringify({
      value: this.ppFilter.value,
      option: this.ppFilter.option,
    });

    if (snapshot === this.lastEmittedSnapshot) {
      return;
    }

    this.filter = this.ppFilter as TAdvancedFilterList;
    this.field = GET_CUSTOM_FIELDS()[this.filter.id];
    this.value = this.filter.value;

    this.option = this.filter.option;

    this.applyChanges();
  }

  changeFieldCondition(newCondition: TSelectOption): void {
    this.filter.option = newCondition.value as TFilterListOptions;
    this.option = newCondition.value as TFilterListOptions;

    if (
      newCondition.value === EAdvancedFilterOptions.IS_EMPTY ||
      newCondition.value === EAdvancedFilterOptions.IS_NOT_EMPTY
    ) {
      this.filter.value = undefined;
      this.value = undefined;
    }

    this.filter.operator = newCondition.operator;

    this.applyChanges();
  }

  private findAndBuildPath(
    idToFind: string,
    list: TCustomField['subList'],
    currentPath: string = '',
  ): { item: TCustomField['subList'][0] | null; path: string | null } {
    for (const item of list) {
      if (item.id === idToFind) {
        const fullPath = currentPath ? `${currentPath}/${item.label}` : item.label;
        return { item: item, path: fullPath };
      }

      if (item.subList && item.subList.length > 0) {
        const nextPath = currentPath ? `${currentPath}/${item.label}` : item.label;

        const result = this.findAndBuildPath(idToFind, item.subList, nextPath);

        if (result.item) {
          return result;
        }
      }
    }

    return { item: null, path: null };
  }

  handleMatchSublist(): void {
    const value = this.filter.value[0];
    this.ppFilter.value = value;

    const { path: fullPath } = this.findAndBuildPath(value, this.field.subList);

    const pathLabel = fullPath || null;

    this.value = {
      id: value as string,
      path: pathLabel,
      label: pathLabel,
      customFields: this.filter.customFields,
    };
  }

  applyChanges(): void {
    if (Array.isArray(this.filter?.value) && this.filter.value.length) {
      this.ppFilter = { ...this.filter };
      this.handleMatchSublist();
    } else if (
      this.filter.option === EAdvancedFilterOptions.IS_EMPTY ||
      this.filter.option === EAdvancedFilterOptions.IS_NOT_EMPTY
    ) {
      this.ppFilter = { ...this.filter, value: [null, ''] };
    } else {
      const filterValue: TAdvancedFilterListValue | undefined = this.filter.value;
      const valueId: string | undefined =
        typeof filterValue === 'string' ? filterValue : filterValue?.id;
      this.ppFilter = { ...this.filter, value: valueId };
    }

    this.lastEmittedSnapshot = JSON.stringify({
      value: this.ppFilter.value,
      option: this.ppFilter.option,
    });
    this.ppFilterChange.emit(this.ppFilter);
  }

  changeFieldValue(value: TAdvancedFilterListValue): void {
    this.filter.value = value;
    this.applyChanges();
  }
}
